import { WellbeingReferralDashboardPage } from "@features/wellbeing-referrals/components/WellbeingReferralDashboardPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/referrals/wellbeing/dashboard")({
    component: WellbeingReferralDashboardPage,
});
